import axiosApi from '../../kits/axiosApi';

function request(rootState, method, url, payload) {
    const aj_host = rootState.aj_host;
    return new Promise((resolve, reject) => {
        const req = method === 'get'
            ? axiosApi.get(aj_host + url, { params: payload })
            : axiosApi.post(aj_host + url, payload);
        req.then((res) => {
            resolve(res.data.data);
        }).catch((err) => {
            reject(err);
        });
    });
}

const actions = {
    getTeamList({ rootState }) {
        return request(rootState, 'get', '/weapp/master/team/list');
    },
    inviteMember({ rootState }, post_data) {
        return request(rootState, 'post', '/weapp/master/team/invite', post_data);
    },
    resendInvite({ rootState }, post_data) {
        return request(rootState, 'post', '/weapp/master/team/resend', post_data);
    },
    revokeInvite({ rootState }, post_data) {
        return request(rootState, 'post', '/weapp/master/team/revoke', post_data);
    },
    removeMember({ rootState }, post_data) {
        return request(rootState, 'post', '/weapp/master/team/remove', post_data);
    },
    resetMemberPassword({ rootState }, post_data) {
        return request(rootState, 'post', '/weapp/master/team/password', post_data);
    },
    changeOwnPassword({ rootState }, post_data) {
        return request(rootState, 'post', '/weapp/master/team/password/self', post_data);
    },
    previewInvite({ rootState }, params) {
        return request(rootState, 'get', '/weapp/master/team/invite/preview', params);
    },
    acceptInvite({ rootState }, post_data) {
        return request(rootState, 'post', '/weapp/master/team/invite/accept', post_data);
    },
};

export default {
    namespaced: true,
    state: {},
    getters: {},
    actions,
    mutations: {},
};
